import request from "./../utils/request";

export function createForm(siteId, title, fields) {
    return request({
        url: "/forms",
        method: "post",
        headers: {
            "site-id": siteId,
        },
        data: {
            title,
            fields,
        },
    });
}

export function updateForm(siteId, formId, formData, formFieldsData) {
    return request({
        url: `/forms/${formId}`,
        method: "put",
        headers: {
            "site-id": siteId,
        },
        data: {
            formData,
            formFieldsData,
        },
    });
}

export function updateFormField(siteId, id, updateFields) {
    return request({
        url: `/forms/form-fields/${id}`,
        method: "put",
        headers: {
            "site-id": siteId,
        },
        data: updateFields,
    });
}

export function updateFormData(siteId, formId, formData) {
    return request({
        url: `/forms/${formId}/data`,
        method: "put",
        headers: {
            "site-id": siteId,
        },
        data: formData,
    });
}

export function updateFormStatus(siteId, submissionId, newStatus) {
    return request({
        url: `/forms/submissions/${submissionId}/status`,
        method: "put",
        headers: {
            "site-id": siteId,
        },
        data: {
            newStatus,
        },
    });
}

export function deleteForm(siteId, formId) {
    return request({
        url: `/forms/${formId}`,
        method: "delete",
        headers: {
            "site-id": siteId,
        },
    });
}

export function deleteFormField(siteId, fieldId) {
    return request({
        url: `/forms/fields/${fieldId}`,
        method: "delete",
        headers: {
            "site-id": siteId,
        },
    });
}

export function getListForm() {
    return request({
        url: "/forms",
        method: "get",
    
    });
}

export function getFormById( formId) {
    return request({
        url: `/forms/${formId}`,
        method: "get",
    });
}


export function getFormSubmissions(siteId, formId, status = "notRead", page = 1, perPage = 10) {
    return request({
        url: `/forms/${formId}/submissions`,
        method: "get",
        headers: {
            "site-id": siteId,
        },
        params: {
            status: status,
            page: page,
            perPage: perPage,
        },
    });
}
export function getFormAnswersBySubmissionId(siteId, submissionId) {
    return request({
        url: `/forms/submissions/${submissionId}`,
        method: "get",
        headers: {
            "site-id": siteId,
        },
    });
}

export function downloadFormDataToPDF(siteId, formId, submissionId = null) {
    return request({
        url: `/forms/${formId}/downloadPDF`,
        method: "get",
        headers: {
            "site-id": siteId,
        },
        params: {
            submissionId: submissionId,
        },
        timeout: 240000, // 4 dakika timeout (240,000 ms)
    });
}

export function downloadFormDataToExcel(siteId, formId, submissionId = null) {
    return request({
        url: `/forms/${formId}/downloadExcel`,
        method: "get",
        headers: {
            "site-id": siteId,
        },
        params: {
            submissionId: submissionId,
        },
        timeout: 240000, // 4 dakika timeout (240,000 ms)
    });
}
